import { useState, useEffect } from "react";

export const useDocumentVisible = (enable?: boolean) => {
    const [documentVisible, setDocumentVisible] = useState("visible");

    useEffect(() => {
        const handleVisibilityChange = () => setDocumentVisible(document.visibilityState);

        if (enable) {
            document.addEventListener("visibilitychange", handleVisibilityChange);
        }

        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, [enable]);

    return documentVisible === "visible";
};
